export const TransactionSimpleState = {
    Success: "Success",
    Failed: "Failed",
    Other: "Other"
}

export const TransactionDetailedState = {
    Unknown: "Unknown",
    Initialized: "Initialized",
    Charging: "Charging",
    Charged: "Charged",
    VendingConfirmed: "Vending Confirmed",
    ProductSelectionFailed: "Product Selection Failed",
    ChargeFailed: "Charge Failed",
    VendingDisconfirmed: "Vending Disconfirmed"
}


export const VendingTransactionState = {
    Unknown: 0,
    Initialized: 1,
    Charging: 2,
    Charged: 3,
    VendingConfirmed: 4,
    ProductSelectionFailed: 21,
    ChargeFailed: 31,
    VendingDisconfirmed: 41
}

export const PaymentTransactionState = {
    Unknown: 0,
    New: 1,
    Reserved: 2,
    ChargedConfirmPending: 3,
    ChargedConfirmed: 4,
    ChargeCanceled: 6,
    ChargeRefunded: 7,
    Charging: 8,
    Reserving: 9,
}

export const VendingHandlerType = {
    Unknown: 0,
    MachineGw1: 1,
    MachineGw2: 2,
    OfflineApp: 3,
    Accounting: 4,
    MachineGwSms: 5,
    Donation: 6,
    Sweepay: 7,
    MachineGwLight: 8,
    CodeGeneratorIntegrated: 9,
    PayOnly: 10,
    SmBackend: 11,
}

export const PaymentChannelType = {
    MoneyStack: 0,
    Wallet: 1,
    ExternalCash: 2,
    ExternalPayPal: 3,
    Mobino: 4,
    WalletExternal: 5,
    TechPsp: 6,
    Twint: 7,
    Sms: 8,
    Voucher: 9,
    VoucherExternal: 20,
    DiMoCo: 21,
    SwisscomPay: 22,
    Cash:30,
    Smarpay:31,
    Cashless1:32,
    Cashless2: 33,
    Mobile: 34,
    Freevend: 40,
    Unknown: 100,
    //Cash: 101, // not from PGW
}

export const TransactionPaymentSubtype = {
    PostFinanceCard: "PFC",
    PostFinanceCard2:  "PostFinance",
    PostFinanceCard3:  "PostFinance Card",
    CreditCards: "ECA,VIS",
    CreditCards2: "Credit card",
    DigitalWallet: "APL,PAY",
    DigitalWallet2:  "ApplePay/GooglePay",
    ApplePay: "APL",
    ApplePay2: "ApplePay",
    ApplePay3: "Apple Pay",
    GooglePay:  "GooglePay",
    GooglePay3:  "Google Pay",
    GooglePay2: "PAY",

    MasterCard:  "MasterCard",
    MasterCard2: "ECA",
    VISA:  "Visa",
    VISA2: "VIS",
    VISA3: "VISA",
    V_PAY:  "V-PAY",
    V_PAY2: "VPY",
    MaestroCard: "MAE" ,
    MaestroCard2: "MaestroCard",

    Reka: "Reka",
    AMX: "AmericanExpress",

    None: "None",
}

export const TransactionPaymentState = {
    ANY: "Any",
    OK: "Valid",
    ERROR: "Error",
}
//set defaults

export const TRANSACTION_PAGE_SIZE = 50000

export const DefaultTransaction2Params = [
    { name: 'startDate', value: new Date().toDateString() },
    { name: 'endDate', value: new Date().toDateString() },

    //{ name: 'vendingState', value: VendingTransactionState.VendingConfirmed }, //4
    //{ name: 'paymentTransactionState', value: PaymentTransactionState.ChargedConfirmed }, //4
    //{ name: 'vendingHandlerType', value: VendingHandlerType.MachineGw1 }, //1
    //{ name: 'vendingHandlerType', value: VendingHandlerType.OfflineApp }, //3
    //{ name: 'vendingHandlerType', value: VendingHandlerType.MachineGwLight }, //8

    { name: 'appendCashTransactions', value: 'true' },
    { name: 'sort', value: 'desc' },
    { name: 'page', value: 0 },
    { name: 'pageSize', value: TRANSACTION_PAGE_SIZE },
]

export const DefaultTransactionSearchParams = [
    { name: 'startDate', value: new Date().toDateString() },
    { name: 'endDate', value: new Date().toDateString() },

    //{ name: 'vendingState', value: VendingTransactionState.VendingConfirmed }, //4
    //{ name: 'paymentTransactionState', value: PaymentTransactionState.ChargedConfirmed }, //4
    //{ name: 'vendingHandlerType', value: VendingHandlerType.MachineGw1 }, //1
    //{ name: 'vendingHandlerType', value: VendingHandlerType.OfflineApp }, //3
    //{ name: 'vendingHandlerType', value: VendingHandlerType.MachineGwLight }, //8

    { name: 'appendCashTransactions', value: 'true' },
    { name: 'sort', value: 'desc' },
    //{ name: 'page', value: 0 },
    { name: 'pageSize', value: TRANSACTION_PAGE_SIZE },

]

/*export class TransactionData {

    sysId: number;
    userId: number;
    userName: string;
    creationUtc: number;
    invoiceId: number;
    vendingState: number;
    vendingAmount: number;
    catererId: number;
    merchantName: string;
    deviceRef: string;
    //"reservationAmount": null,
    //"reservationUtc": null,
    saleDomainId: number;
    paymentTrans1amount: number;
    paymentTrans1bookingUtc: number;
    paymentTrans1paymentType: number;
    paymentTrans1state: number;
    //"paymentTrans1dRefundUtc": null,
    //"paymentTrans2amount": null,
    //"paymentTrans2bookingUtc": null,
    //"paymentTrans2paymentType": null,
    //"paymentTrans2state": null,
    //"paymentTrans2dRefundUtc": null,
    //"lastModUtc": 1633086426743,
    triggerType: number;
    triggerPaymentType: number;
    vendingHandlerType: number;
    vendApprovedUtc: number;
    vendFinishedUtc: number;
    voucherId: number;
    //"voucherRef": null,
    //"voucherState": null,
    //"userMessage": null,
    //"article": null,
    // "selectedCode": 43,
    merchantRef: string;
    //"networkCode": null,
    //"vendingDeviceSubitemRef": null,
    //"vendingDeviceSubitemName": null,
    //"externalCardRef": null,
    //"cardName": null,
    //"paymentTrans1paymentSubType": null,
    //"paymentTrans2paymentSubType": null,
    //"invoiceExternalRef4": null,
    //"errorCode": null,
    //"serviceProviderId": null,
    //"serviceProviderName": null,
    fromDt: number;
    toDt: number;
    brand: string;
}
}

export enum VendingTransactionState {
    Unknown = 0,
    Initialized = 1,
    Charging = 2,
    Charged = 3,
    VendingConfirmed = 4,
    ProductSelectionFailed = 21,
    ChargeFailed = 31,
    VendingDisconfirmed = 41
}

export enum PaymentChannelType {
    BusinessAccount = 1,
    PayPal = 3,
    DataTrans = 6,
    Twint = 7,
    Sms = 8,
    DiMoCo = 21,
    SwisscomPay = 22,
    Cash = 101, // not from PGW
}

export enum TransactionPaymentSubtype {
    PostFinanceCard = "PFC",
    CreditCards = "ECA,VIS",
    DigitalWallet = "APL,PAY",
    ApplePay = "APL",
    GooglePay = "PAY",
    None = "None",
}

export enum TransactionPaymentState {
    ANY = "Any",
    OK = "OK",
    Error = "Error",
}*/